import {
  FaHome,
  FaCalendarAlt,
  FaUsers,
  FaChartBar,
} from "react-icons/fa";

export interface V2NavItem {
  nameKey: string;
  href: string;
  icon: typeof FaHome;
}

export const V2_NAV_ITEMS: V2NavItem[] = [
  { nameKey: "v2.nav.home", href: "/v2/home", icon: FaHome },
  { nameKey: "v2.nav.matches", href: "/v2/matches", icon: FaCalendarAlt },
  { nameKey: "v2.nav.squad", href: "/v2/squad", icon: FaUsers },
  { nameKey: "v2.nav.stats", href: "/v2/stats", icon: FaChartBar },
];
